import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

interface SelectedLov {
  lovType: string;
  selectedLov: any;
}

@Injectable({
  providedIn: 'root',
})
export class LovSelectionService {
  private selectedLovs: SelectedLov[] = [];
  private selectedLovs$ = new BehaviorSubject<SelectedLov[]>([]);

  // Observable for subscription
  // This method is used to get lov selections
  getLovSelections() {
    return this.selectedLovs$.asObservable();
  }

  // Add or update LOV
  // This method is used to set lov selection using lov type and selected lov
  setLovSelection(lovType: string, selectedLov: any) {
    const index = this.selectedLovs.findIndex((item) => item.lovType === lovType);

    if (index !== -1) {
      this.selectedLovs[index].selectedLov = selectedLov;
    } else {
      this.selectedLovs.push({ lovType, selectedLov });
    }

    this.selectedLovs$.next([...this.selectedLovs]);
  }

  // Get latest selection by type
  // This method is used to get latest by lov type using lov type
  getLatestByLovType(lovType: string): SelectedLov | undefined {
    return this.selectedLovs
      .slice()
      .reverse()
      .find((item) => item.lovType === lovType);
  }

  // This method is used to get latest parent value using lov type and key
  getLatestParentValue(lovType: string, key: string): any {
    const lovs = this.selectedLovs.slice().reverse();
    const parent = lovs.find((x) => x.lovType === lovType);
    return parent?.selectedLov?.[key] ?? null;
    // return this.getLovSelections().pipe(
    //   map((lovs) => {
    //     const parent = lovs
    //       .slice()
    //       .reverse()
    //       .find((x) => x.lovType === lovType);

    //     return parent?.selectedLov?.[key] ?? null;
    //   })
    // );
  }

  // Clear all selections
  // This method is used to reset
  reset() {
    this.selectedLovs = [];
    this.selectedLovs$.next([]);
  }
}
